export enum AppRole {
  BAMBOO_ADMIN = 'BAMBOO_ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  USER = 'USER',
  OVERSEAS_CARE_NAVIGATOR = 'OVERSEAS_CARE_NAVIGATOR',
}

export enum Feature {
  CLIENT_LIST = 'CLIENT_LIST',
  CLIENT_PROFILE = 'CLIENT_PROFILE',
  FORMS = 'FORMS',
  LOG = 'LOG',
  NOTIFICATIONS = 'NOTIFICATIONS',
  STATE_REPORTING = 'STATE_REPORTING',
  USER_PERMISSIONS = 'USER_PERMISSIONS',
  USER_PROFILE = 'USER_PROFILE',
  USER_REPORTING = 'USER_REPORTING',
  TASKS = 'TASKS',
  NETWORK_REGISTRY = 'NETWORK_REGISTRY',
  REFERRALS = 'REFERRALS',
}

export enum FeaturePermissionLevel {
  VIEW = 'VIEW',
  ACT = 'ACT',
  MANAGE = 'MANAGE',
}

export enum FeatureNew {
  CLIENT_LIST = "CLIENT_LIST",
  FORMS = "FORMS",
  ADMIN_MANAGEMENT = "ADMIN_MANAGEMENT",
  ANALYTICS = "ANALYTICS",
  TASKS = "TASKS",
  REFERRALS = "REFERRALS",
  MY_NETWORK = "MY_NETWORK",
  NETWORK_REGISTRY_BROWSER= "NETWORK_REGISTRY_BROWSER",
  NETWORK_FACILITIES_UNITS = "NETWORK_FACILITIES_UNITS",
}

export const FeaturePermissionLevelHierarchy = [
  FeaturePermissionLevel.VIEW,
  FeaturePermissionLevel.ACT,
  FeaturePermissionLevel.MANAGE,
];

export enum DataSource {
  ADT = 'ADT',
  FINDHELP = 'FINDHELP',
  JI = 'JI',
  OB_CRISIS = 'OB_CRISIS',
  OB_REFERRALS = 'OB_REFERRALS',
  PDMP = 'PDMP',
  ROUNDTRIP = 'ROUNDTRIP'
}

export enum DataPermissionLevel {
  READ = 'READ',
  WRITE = 'WRITE',
  SSO = 'SSO',
}

export enum DataPermissionLevelNew {
  VIEW = 'VIEW',
  SSO = 'SSO',
  ACT = 'ACT',
}

export const NewDataPermissionLevelHierarchy = [
  DataPermissionLevelNew.VIEW,
  DataPermissionLevelNew.ACT,
  DataPermissionLevelNew.SSO
];

export const DataPermissionLevelHierarchy = [
  DataPermissionLevel.READ,
  DataPermissionLevel.WRITE,
  DataPermissionLevel.SSO,
];

export interface DataPermission {
  id: number,
  data_role_id: number,
  data_source: DataSource,
  level: DataPermissionLevel,
}

export interface DataRole {
  id: string,
  name: string,
  permissions: DataPermission[]
}

export interface FeaturePermission {
  id: number,
  feature_role_id: number,
  feature: Feature,
  level: FeaturePermissionLevel,
}

export interface FeatureRole {
  id: string,
  name: string,
  permissions: FeaturePermission[]
}

export interface EffectivePermissions {
  byRoster: Record<number, PermissionSet>,
  anyRoster: PermissionSet,
}

export interface PermissionSet {
  featurePermissions: Partial<Record<Feature, FeaturePermissionLevel>>,
  dataPermissions: Partial<Record<DataSource, DataPermissionLevel>>,
  featurePermissionsNew: Partial<Record<FeatureNew, FeaturePermissionLevel>>,
  dataPermissionsNew: Partial<Record<DataSource, DataPermissionLevelNew>>,
  units: string[],
}
